import { render, staticRenderFns } from "./barCode.vue?vue&type=template&id=55a8720b&"
import script from "./barCode.vue?vue&type=script&lang=js&"
export * from "./barCode.vue?vue&type=script&lang=js&"
import style0 from "./barCode.vue?vue&type=style&index=0&id=55a8720b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports